import React from 'react';
import { Link } from '../ui/link';

interface BreadcrumbItem {
  label: string;
  path: string;
  state?: any;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  return (
    <nav aria-label="Breadcrumb" className="mb-4">
      <ol className="flex items-center gap-2 text-sm">
    
        <li>
          <Link to="/main" variant="default" underline="hover">
            Home
          </Link>
        </li>
        
        {items.map((item, index) => (
          <li key={item.path} className="flex items-center gap-2">
            <span className="text-gray-400">/</span>
            
            {index === items.length - 1 ? (
              <span className="text-paragraph">{item.label}</span>
            ) : (
              <Link to={item.path} state={item.state} variant="default" underline="hover">
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;